import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
    auth: true
};

export default {
    path: 'stock',
    name: 'stock',
    component: BasicLayout,
    children: [{
            path: 'add',
            name: "stock-add",
            component: () => import("@/pages/admin/stock/add.vue"),
            meta: {
                ...meta,
                title: '添加库存 - 极客商城系统'
            }

        }, {
            path: 'list',
            name: "stock-list",
            component: () => import("@/pages/admin/stock/list.vue"),
            meta: {
                ...meta,
                title: '库存列表 - 极客商城系统'
            }
        },
        {
            path: "*",
            redirect: '/home'
        },

    ]
};